import React, { useEffect, useState } from 'react'
import VendorStore from '../../../../components/atoms/vendorStores'
import CardWrapper from '../../../../components/molecules/CardWrapper'
import CardHeader from '../../../../components/atoms/cardHeader'
import { Col, Row } from 'antd'
import { GetProductDetails, GetVariantWithoutInventory, SaveStock } from '../../../../store/thunks/productThunk'
import { useLocation, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import DetailedProduct from './components/DetailedProduct'
import MediaSlider from '../../../../components/atoms/mediaSlider'
import InventoryModal from '../../../../components/atoms/inventoryModal'
import { resetStock } from '../../../../store/slices/productSlice'

const ProductPreview = () => {
    const dispatch = useDispatch();
    const { id, base } = useParams();
    const { data } = useSelector((state) => state.productDetails);
    const { storeId, storeName } = useSelector((state) => state?.storeData || {});
    const { data: stockData } = useSelector((state) => state?.saveStockData);
    const { feedSupplementDetailedResponse, machineryDetailedResponse, productDetailedResponse, seedDetailedInformationResponse } = data || {};
    const [detail, setDetail] = useState({});
    const [success, setSuccess] = useState(false);
    const [inventoryValues, setInventory] = useState({
        productId: id,
        cashOnDeliveryStatus: false
    });
    const [errors, setErrors] = useState();

    useEffect(() => {
        const baseMap = {
            NUTRITION: productDetailedResponse,
            SEEDS: seedDetailedInformationResponse,
            FEED_SUPPLEMENT: feedSupplementDetailedResponse,
            MACHINERY: machineryDetailedResponse,
        };

        setDetail(baseMap[base] || {});
    }, [base, productDetailedResponse, seedDetailedInformationResponse, feedSupplementDetailedResponse, machineryDetailedResponse]);


    useEffect(() => {
        dispatch(GetProductDetails({
            productId: id,
            productBase: base
        }))
    }, [id])

    useEffect(() => {
        if (stockData) {
            setSuccess(true);
            dispatch(resetStock());
        }
    }, [stockData])

    useEffect(() => {
        if(storeId){
            setInventory({
                ...inventoryValues,
                inventoryId: storeId,
                inventoryName: storeName,
            });
            dispatch(GetVariantWithoutInventory({
                productId: id,
                inventoryId: storeId,
            }))
        }
        else{
            setInventory({
                ...inventoryValues,
                inventoryId: "",
                inventoryName: "",
            });
            dispatch(GetVariantWithoutInventory({
                productId: id,
                inventoryId: "",
            }))
        }
    }, [storeId, id])



    const handleSubmit = () => {
        const { inventoryName, ...rest } = inventoryValues;
        dispatch(SaveStock({ payload: rest }));
    }

    return (
        <div className="content d-flex flex-column flex-column-fluid">
            <div className="container d-flex flex-sm-nowrap flex-wrap justify-content-around justify-content-lg-between">
                <div className="align-items-center d-flex justify-content-end pb-6">
                    <VendorStore isClearable={true}/>
                    <span
                        className={`btn btn-primary font-weight-bold letter-spacing btn-md ${inventoryValues?.inventoryId ? "" : "disabled"
                            }`}
                        data-toggle="modal"
                        data-target={
                            inventoryValues?.inventoryId ? "#InventorymodalScrollable" : ""
                        }
                    >
                        Add to Inventory
                    </span>
                </div>
            </div>

            <CardWrapper>
                <CardHeader name={detail?.name?.en + " - " + detail?.productDetails?.brand?.name?.en} tooltipText={"Review complete product information, specifications, usage instructions, and multilingual content before adding it to inventory."} />
                <div className="card-body p-4">
                    <Row gutter={[10, 10]} className="disabled-color">
                        <Col xs={24} lg={17}>
                            <DetailedProduct productbase={base} detail={detail} />
                        </Col>
                        <Col xs={24} lg={7}>
                            <MediaSlider images={detail?.images?.map((obj) => obj.image)} videos={detail?.videos} />
                        </Col>
                    </Row>
                </div>
            </CardWrapper>

            <InventoryModal type={"Add"} setInventory={setInventory} inventoryValues={inventoryValues} detail={detail} errors={errors} setErrors={setErrors} success={success} setSuccess={setSuccess} inventoryFunction={handleSubmit} />
        </div>
    )
}

export default ProductPreview